export const googleMapURL =
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyBAja0D4Mwm-V6WYweHaMJYFibY_aD0F1A&v=3.36';

export default googleMapURL;
